// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3JOVU","content":"LayoutSettings_content__apU5A"};